module.exports = __webpack_public_path__ + "static/deloitte_timeline-0d3d617d15f4d1c9718d9791c28de501.jpg";